export default __webpack_public_path__ + "static/media/footer-card-image-mobile.db28c728.svg";